import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {CCTwoInitialWPEvents} from "../winpresentation/initial/CreepyCarnivalTwoInitialWPController";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {Circ, SlowMo, TimelineLite, TweenLite} from "gsap";
import {CreepyCarnivalTwoGameConfig} from "../CreepyCarnivalTwoGameConfig";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {CreepyCarnivalTwoParsedInitData} from "../server/data/CreepyCarnivalTwoParsedInitData";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {CreepyCarnivalBulbsEvent} from "../utils/CCTwoBulb";
import {Button} from "@nolimitcity/slot-game/bin/core/component/Button";

export class CCTwoStarStatusScreen extends BaseView {
    protected _layer: ScalableLayer;
    protected _isShowing: boolean = false;
    private _container: PIXI.Container;
    private _statusBanner: PIXI.Sprite;
    private _spiceUp: PIXI.Text;
    private _collectStars: PIXI.Text;
    private _close_button: Button;
    private _close_button_Image: PIXI.Sprite;
    private _timeline: TimelineLite | null;
    private _introBannerContainer: PIXI.Container;
    private _timelineIntroBanner: TimelineLite | null;
    private _specialSymbolsArray: any[];
    private playedBet: number[] = [];
    private _mt: PIXI.Container = new PIXI.Container();

    constructor() {
        super();

        this._layer = StageManager.getLayer(CreepyCarnivalTwoGameConfig.instance.LAYERS.STAR_STATUS_SCREEN.name);
        this._layer.addChild(this);
    }

    public show(): void {
        if (this._isShowing) {
            return;
        }

        this.emptyArray();
        this.playedBet = [];

        this.createStarSpinStatusSymbols(this._specialSymbolsArray);

        this._isShowing = true;

        this.visible = true;
        this.startPresentation();
    }

    public close(): void {
        if (!this._isShowing) {
            return;
        }
        EventHandler.dispatchEvent(new GameEvent(CCTwoInitialWPEvents.STAR_STATUS_SCREEN_HIDDEN));
        this.stopPresentation();
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, CCTwoInitialWPEvents.DISPLAY_STATUS_SCREEN, (event: GameEvent) => this.show());
        EventHandler.addEventListener(this, CCTwoInitialWPEvents.HIDE_STATUS_SCREEN, (event: GameEvent) => this.close());
        EventHandler.addEventListener(this, ReelEvent.REEL_SPIN_STARTED, (event: GameEvent) => this.close());
        EventHandler.addEventListener(this, CreepyCarnivalBulbsEvent.HIDE_STAR_SPIN_BULBS, (event: GameEvent) => this.emptyArray());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onDataParsed(event.params[0]));
    }

    protected initAnimations(): void {
        this.addChild(this.createGameGraphics());
    }

    protected createGameGraphics(): PIXI.DisplayObject {
        this._container = new PIXI.Container();
        const introBannerContainer: PIXI.Container = new PIXI.Container();
        this._statusBanner = new PIXI.Sprite(GameResources.getTextures("curtain")[0]);
        let bannerMask = new PIXI.Graphics();
        bannerMask.beginFill(0x000000, 0.8);
        bannerMask.drawRect(0, 99, 1200, 900);
        bannerMask.endFill();
        this._container.addChild(bannerMask);
        introBannerContainer.mask = bannerMask;
        this._statusBanner.anchor.set(0.5, 0.5);
        this._statusBanner.position.set(641, 325);
        this._statusBanner.scale.set(0.998, 1);

        this._close_button_Image = new PIXI.Sprite(GameResources.getTextures("assets/button-disabled")[0]);
        this._close_button_Image.anchor.set(0.5, 0.5);
        this._close_button_Image.position.set(975, 122);
        this._close_button_Image.visible = true;
        this._close_button_Image.alpha = 1;

        const textures = {
            idle: GameResources.getTextures("ui/gameTweakerButton/button-disabled")[0],
            over: GameResources.getTextures("ui/gameTweakerButton/button-disabled")[0],
            down: GameResources.getTextures("ui/gameTweakerButton/button-disabled")[0],
            disabled: GameResources.getTextures("ui/gameTweakerButton/button-disabled")[0]
        };
        this._close_button = new Button(textures, () => this.close());
        this._close_button.position.set(975, 122);
        this._close_button.anchor.set(0.5, 0.5);
        this._close_button.visible = false;
        introBannerContainer.addChild(this._statusBanner);
        introBannerContainer.addChild(this._mt);

        this._collectStars = new PIXI.Text(Translation.translate("Collect 13 stars via high value symbol wins to receive your FREE Star Spin."), {
            fill: 0xC8B755,
            fontSize: "18px",
            align: "center",
            fontStyle: "italic",
            fontFamily : 'Arial'
        });
        this._collectStars.anchor.set(0.5, 0.5);
        this._collectStars.x = 630;
        this._collectStars.y = 520;
        this._collectStars.scale.set(0.75,0.75);
        introBannerContainer.addChild(this._collectStars);

        this._spiceUp = new PIXI.Text(Translation.translate("To spice things up, we will add 2 WILD symbols to almost ensure guaranteed free winnings!"), {
            fill: 0xC8B755,
            fontSize: 12,
            align: "center",
            fontStyle: "italic"
        });
        this._spiceUp.anchor.set(0.5, 0.5);
        this._spiceUp.x = 630;
        this._spiceUp.y = 535;
        introBannerContainer.addChild(this._spiceUp);
        this._introBannerContainer = introBannerContainer;
        this._introBannerContainer.addChild(this._close_button_Image);
        this._container.addChild(this._close_button);
        this._container.addChild(this._introBannerContainer);

        this.visible = false;

        return this._container;
    }

    protected startPresentation(): void {
        if (!this._timeline) {
            this._introBannerContainer.visible = false;

            const timeline: TimelineLite = new TimelineLite({paused: true});
            timeline.add(() => {
                this.playIntroBannerAnimation();
            }, timeline.totalDuration());
            this._timeline = timeline;
        }
        this._timeline.play(0);
    }

    protected playIntroBannerAnimation(): void {
        if (!this._timelineIntroBanner) {
            const timeline: TimelineLite = new TimelineLite({paused: true});
            timeline.add(() => {
                this._introBannerContainer.visible = true;

            },);
            timeline.add([
                TweenLite.fromTo(this._introBannerContainer, 0.7, {y: -500}, {y: 0, ease: Circ.easeOut}),
            ]);
            this._timelineIntroBanner = timeline;
        }
        setTimeout(() => {
            this._close_button.visible = true;
        }, 250);
        this._timelineIntroBanner.play(0);
    }

    protected stopPresentation(): void {
        const timeline: TimelineLite = new TimelineLite({
            paused: true,
            onComplete: () => {
                this.visible = false;
            }
        });

        this._isShowing = false;

        timeline.add([
            TweenLite.fromTo(this._introBannerContainer, 0.7, {y: 0}, {
                y: -500,
                ease: SlowMo.ease.config(0.8, 0.2, false)
            }),
        ]);

        timeline.add(() => {
            this._introBannerContainer.visible = false;
            if (this._timeline) {
                this._timeline.kill();
                this._timeline = null;
            }
            if (this._timelineIntroBanner) {
                this._timelineIntroBanner.kill();
                this._timelineIntroBanner = null;
            }
        });

        setTimeout(() => {
            this._close_button.visible = false;
            EventHandler.dispatchEvent(new GameEvent(CCTwoInitialWPEvents.STAR_STATUS_SCREEN_HIDDEN));
        }, 250);

        timeline.play(0);
    }

    private emptyArray(): void {
        this._mt.removeChildren();
    }

    private onDataParsed(data: CreepyCarnivalTwoParsedInitData): void {
        this._specialSymbolsArray = data.getSpecialSymbolsArray;
    }

    private createStarSpinStatusSymbols(arr: any[]): void {
        let child, text, x, y, j = 0;

        for (let i = 0; i < arr.length; i++) {
            let sym: string = arr[i].symbol;
            child = new PIXI.Sprite(GameResources.getTextures("assets/" + sym.toLowerCase() + "_collect")[0]);
            if (i < 7) {
                x = 360;
                y = 226;
            } else {
                j = (j === 7) ? 0 : j;
                x = 406;
                y = 320;
            }
            child.position.set(x + (93 * j), y);
            child.anchor.set(0.5);

            const noDecimals = arr[i].betValue >= 10 && arr[i].betValue.toFixed(2).endsWith('00');
            if (noDecimals) {
                this.playedBet.push(arr[i].betValue.toFixed(0));
            } else {
                this.playedBet.push(arr[i].betValue.toFixed(2));
            }

            text = new PIXI.Text(this.playedBet[i].toString(), {
                fontFamily: 'Insane Rodeo Bold',
                fontSize: 18,
                fill: 0xffffff,
                align: 'center'
            });
            text.anchor.set(0.5, 0.5);
            text.position.set(x + (93 * j), y - 50);
            j++;
            this._mt.addChild(child);
            this._mt.addChild(text);
        }
    }

    update(starSpinSymbolsCollectedAfter:any[]) {
        this._specialSymbolsArray = starSpinSymbolsCollectedAfter;
    }
}